import { WhitelistAction } from '../global';

export const TRAVELLER_DETAILS = 'TRAVELLER_DETAILS';
export const TRAVELLER_DETAILS_ERRORS = 'TRAVELLER_DETAILS_ERRORS';
export const COVERME_TRAVELLER_DETAILS = 'COVERME_TRAVELLER_DETAILS';
export const COVERME_ORIGINAL_TRAVELLER_DETAILS = 'COVERME_ORIGINAL_TRAVELLER_DETAILS';

export interface TravellerDetails {
  originalFormData?: {
    [props: string]: TravellerDetailsPayload;
  };
  formData?: {
    [props: string]: TravellerDetailsPayload;
  };
  errors?: {
    [props: string]: TravellerDetailsPayload;
  };
}

export interface TravellerDetailsPayload {
  agent?: string
  firstName?: string;
  lastName?: string;
  email?: string;
  confirmEmail?: string;
  phone?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  addressSameAsPrimary?: string;
  emailPhoneSameAsPrimary?: string;
  // Coverme Traveller Details Field
  travellerType?: string;
  travellerCount?: number;
  dependents?: boolean;
  dateOfBirth?: Date;
  paxId?: number;
  planCoverageDayCount?: number;
  alternatePhone?: string;
  relationship?: string;
  language?: string;
  homeCountry?: string;
  bill96Consent?: boolean;
}

export interface TravellerDetailsActionPayload extends WhitelistAction {
  formName: string;
}

export interface TravellerDetailsAction {
  type: string;
  payload?: TravellerDetailsActionPayload;
}
